import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress // Bu import gerekli
} from '@material-ui/core';
import { Cancel, CheckCircle } from '@material-ui/icons';
import EyatUIDatePicker from './EyatUIDatePicker';

export default function BirthDatePickerDialog({ open, onClose, onSave, value, onChange, loading }) {
    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title" maxWidth="xs" fullWidth>
            <DialogTitle id="form-dialog-title">Doğum Tarihinizi Seçiniz</DialogTitle>
            <DialogContent>
                <EyatUIDatePicker
                    containerId="birth-date-picker"
                    label="Doğum Tarihi"
                    disableFuture={true}
                    dateString={value}
                    setContainerSelectedDate={onChange}
                    noMargin
                />
            </DialogContent>
            <DialogActions style={{ padding: '16px 24px' }}>
                <Button onClick={onClose} color="secondary" startIcon={<Cancel />}>
                    İptal
                </Button>
                <Button
                    onClick={onSave}
                    color="primary"
                    variant="contained"
                    disabled={loading || value === ""}
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
                >
                    Doğrula
                </Button>
            </DialogActions>
        </Dialog>
    );
}